import { render, staticRenderFns } from "./MyHabitsChartProgress.vue?vue&type=template&id=db2252be"
import script from "./MyHabitsChartProgress.vue?vue&type=script&lang=js"
export * from "./MyHabitsChartProgress.vue?vue&type=script&lang=js"
import style0 from "./MyHabitsChartProgress.vue?vue&type=style&index=0&id=db2252be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports